export default {
  DESELECT_ALL_ICONS: 'selection/DESELECT_ALL_ICONS',
  DESELECT_ICON: 'selection/DESELECT_ICON',
  SELECT_ICON: 'selection/SELECT_ICON',
  SELECT_ICONS: 'selection/SELECT_ICONS',
  SELECT_ADDITIONAL_ICONS: 'selection/SELECT_ADDITIONAL_ICONS'
};
